// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgChevronLeftIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M14.757 6.314a1.07 1.07 0 0 0-1.514 0l-4.929 4.929a1.07 1.07 0 0 0 0 1.514l4.929 4.929a1.07 1.07 0 1 0 1.514-1.514l-4.166-4.177 4.166-4.167a1.08 1.08 0 0 0 0-1.514"
    />
  </g>
);
export default SvgChevronLeftIcon;
SvgChevronLeftIcon.displayName = 'SvgChevronLeftIcon';
